import React, { Component } from 'react';


import TotalComponent from '../components/ChartTotalDashboard/TotalComponent'
import './../../selections/timeSelection/components/timeSelect/cliente.css';


//Actualizacion develop
class TotalDB extends Component {

  render() {
    const { data, name, title, colors } = this.props;
    return (
      <TotalComponent
        name={name}
        title={title}
        data={data}
        colors={colors}
        openDialog={this.props.openDialog}
        onClickGraphic={this.props.onClickGraphic}
        seeMore={this.props.seeMore}
      />
    );
  }
}

export default TotalDB;